@if (Vendor) {
  <div class="container-fluid d-flex flex-column h-100 mt-4 ps-4">
    <!-- Page head: title + primary action, same row. -->
    <div class="row align-items-center">
      <div class="col d-flex justify-content-between align-items-center">
        <h2 class="mb-0">
          Documents{{ Vendor.legalName ? ' - ' + Vendor.legalName : '' }}
        </h2>
        <button class="btn btn-primary" (click)="addCompanyVendorFile()">
          Add a document
        </button>
      </div>
    </div>

    <!-- Documents section utility bar + grid. -->
    <form [formGroup]="CompanyVendorFileActionForm" class="row mt-3">
      <div class="col d-flex justify-content-end">
        <div class="check-group mt-0">
          <input
            id="docsShowArchived"
            type="checkbox"
            class="form-check-input"
            formControlName="showArchived"
          />
          <label for="docsShowArchived" class="form-check-label mt-0">
            Show archived?
          </label>
        </div>
      </div>
    </form>
    <div class="row flex-grow-1 mt-2 mb-4">
      <div class="col">
        @if (CompanyVendorFilesSuppliedGridQueryData) {
          <app-company-vendor-files-grid
            [suppliedQueryData]="CompanyVendorFilesSuppliedGridQueryData"
            [gridName]="'ClientVendorDocuments'"
            [ColumnIdToColumnActions]="ColumnIdToColumnActions"
            [suppressFieldDotNotation]="true"
            [(reloadGridData)]="reloadCompanyVendorFileGrid"
            (actionEvent)="companyVendorFileAction($event)"
          >
          </app-company-vendor-files-grid>
        }
      </div>
    </div>

    <!-- Signed Documents section. Section header + utility bar + grid. -->
    @if (CompanyVendor?.VendorId && hasAcceptedSignedDocumentRole) {
      <div class="row align-items-center mt-2">
        <div class="col">
          <h2 class="mb-0">Signed documents</h2>
        </div>
      </div>
      <form [formGroup]="SignedDocumentActionsForm" class="row mt-3">
        <div class="col d-flex justify-content-end">
          <div class="check-group mt-0">
            <input
              id="signedShowArchived"
              type="checkbox"
              class="form-check-input"
              formControlName="showArchived"
            />
            <label for="signedShowArchived" class="form-check-label mt-0">
              Show archived?
            </label>
          </div>
        </div>
      </form>
      <div class="row flex-grow-1 mt-2 mb-4">
        <div class="col">
          @if (SignedDocumentsSuppliedGridQueryData) {
            <app-signed-documents-grid
              [suppliedQueryData]="SignedDocumentsSuppliedGridQueryData"
              [gridName]="'ClientAdminSignedDocuments'"
              [ColumnIdToColumnActions]="ColumnIdToColumnActions"
              [(reloadGridData)]="reloadSignedDocumentsGrid"
              (actionEvent)="signedDocumentsAction($event)"
            >
            </app-signed-documents-grid>
          }
        </div>
      </div>
    }
  </div>
}
